import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  authToken: null,
};
const authSlice = createSlice({
  reducerPath: 'auth',
  name: 'auth',
  initialState,
  reducers: (create) => ({
    // dummy action for listener
    init: create.reducer((state) => state),
    // mostly for internal usage (dispatch from listeners)
    setToken: create.reducer((state, { payload }) => {
      state.authToken = payload;
    }),
    // 'public' action for user sign-in
    signIn: create.reducer((state, { payload: token }) => {
      state.authToken = token;
    }),
    // 'public' action for user sign-out
    signOut: create.reducer((state) => {
      state.authToken = null;
    }),
    // dummy action for listener
    invalidateStores: create.reducer((state) => state),
  }),
});

const { actions } = authSlice;
export default authSlice;
export const { init, setToken, invalidateStores, signIn, signOut } = actions;
